import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col, Checkbox, Popover, Icon, Table, Button} from 'antd';
import {formatDate} from "../../../../utils";
import '../TableList.css'
import PageTableComponent from "../pageTable/PageTable";
import defaultImg from  './img/default.png'
import BaseComponent from "../../../../base/BaseComponent";

export default class TableList extends BaseComponent {
    static defaultProps = {
        checked: false,
        dataSource: [],
        doubleClick: () => {

        },
        IsChecked: () => {

        }
    };
    static propTypes = {
        dataSource: PropTypes.array.isRequired,//传入的数据
        checked: PropTypes.bool,//是否选中
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }
    render() {
        return (
            <div style={{cursor: 'pointer',}} onDoubleClick={() => {
                this.props.doubleClick && this.props.doubleClick()
            }}>
                {this.renderFileList()}
            </div>)
    }

    //渲染列表
    renderFileList() {
        let columns = [
            {
                title: '名称',
                dataIndex: 'name',
                key: 'name',
                width: 500,
                ellipsis: true,
                render: (text, record, index) => {
                    let title = '';
                    // if (text.length > 10) {
                    //     title = (text).substring(0, 10) + "...";
                    // } else {
                    //     title = text
                    // }
                    title = text
                    return (
                        <div className={'twoText'} onClick={() => {
                            this.props.onClick && this.props.onClick(record)
                        }}>
                            <img src={record.icon ? record.icon : defaultImg}
                                 style={{width: '20px', height: '20px', marginTop: '5px', objectFit: 'cover'}}/>
                            <span style={{marginLeft: '8px'}} title={text}>{title}</span>
                            {record.extendedAttributeJson && record.extendedAttributeJson.download ?
                                <Icon type="lock" style={{color: '#0050B3', marginLeft: 5}}/> : null}
                        </div>
                    )
                }
            },
            {
                title: '最近修改时间',
                dataIndex: 'updateTime',
                render: (text, record, index) => {
                    return (
                        <div>{text ? formatDate(text) : ''}</div>
                    )
                }
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                render: (text, record, index) => {
                    return (
                        <div>{formatDate(text)}</div>
                    )
                }
            },
        ];
        if (this.props.btnNames.length) {
            columns.push({
                title: '操作',
                dataIndex: 'address',
                render: (text, record) => {
                    let array = []
                    array.push(record);
                    let curretBtn = [];
                    this.props.btnNames && this.props.btnNames.length && this.props.btnNames.forEach((item, index) => {
                        if (item === 'MyUpload' || item === 'NewFolder') {
                        } else {
                            curretBtn.push(item) //去掉上传按钮  以及新建文件夹按钮
                        }
                    });
                    let newBtn = curretBtn.slice(0, 3);
                    let AbbreviationBtn = curretBtn.slice(3);//截取前三个  剩下的  功能
                    let newArray = [ ...AbbreviationBtn];
                    let checkArray = [];
                    checkArray.push(record);
                    const content = (
                        <div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), lineHeight: '40px'}}>
                            {this.renderBtnList(record, newArray, checkArray)}
                        </div>
                    );
                    return (<div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), display:'flex'}}>
                        <div style={{display:'flex'}}> {this.renderBtnList(record, newBtn, checkArray)}</div>
                        <div style={{background:'#0000000'}}>  {newArray.length > 0 ? <Popover placement="right"
                                                               onVisibleChange={() => this.handleVisibleChange(record)}
                                                               visible={record.moreVisible}
                                                               content={content} trigger="click">
                            <Icon type="ellipsis" style={{marginTop: 5,marginLeft:5}} onClick={() => {
                                this.showMoreVisible.bind(this)
                            }}/>
                        </Popover> : null}</div>

                    </div>)
                }
            })
        }


        return (
            <div>
                <PageTableComponent
                    positionHeight={44}
                    columns={columns}
                    className={"tabList"}
                    rowSelection={this.props.btnNames.length ? this.props.rowSelection : null}
                    rowKey={this.props.rowKey}
                    data={this.props.dataSource}
                    page={this.props.page}
                    size={this.props.size}
                    count={this.props.count}
                    onChangePage={(page, size) => {
                        this.props.onChangePage(page, size)
                    }}
                ></PageTableComponent>

            </div>)
    }

    renderBtnList = (record, btnList, checkArray) => (
        btnList&&btnList.length&&btnList.map((item,index)=>{
            let ItemComponent = require(`../${item}.js`);
            let ItemComponentDefault = ItemComponent.default;
            return <ItemComponentDefault
                key={index}
                currentId={record.fid}
                current={this.props.current}
                hideCallBack={() => {
                    this.showMoreVisible(record)
                }}
                resourceName={this.props.resourceName}
                checkArray={checkArray} IsTile={this.props.IsTile} text={true} callBack={() => {
                this.props.callBack && this.props.callBack()
            }}
            />;
        })
    );

    handleVisibleChange(record) {
        record.moreVisible = !record.moreVisible;
        this.setState({})
    }
    showMoreVisible(record) {
        record.moreVisible = false;
        this.setState({})
    }


    //表格行背景色
    getRowClassName = (record, index) => {
        let className = '';
        className = index % 2 === 0 ? "evenRow" : "oddRow";
        return className;
    };
}
